import React, { useState, useEffect, useCallback } from 'react'
import RenderModal from '../../modal/renderModal'
import ModalWrapper from '../../modal/modalWrapper'
import { useTimeTableApi, useTimeTableContext } from '../../../contexts/timeTableContext'
import { isEmpty } from 'lodash'
import AttributeRevision from '../../modal/attributeRevision'

function RndModal() {
  const { rndModal, selectedTimeEntry } = useTimeTableContext()
  const { toggleState, updateRndEntry, updateState, createRndEntry } = useTimeTableApi()

  const { rnd_entry } = selectedTimeEntry || {}
  const [description, setDescription] = useState("")

  useEffect(() => {
    setDescription(rnd_entry?.description || "")
  }, [rnd_entry])

  const updateDescription = useCallback(() => {
    if (!rnd_entry) {
      createRndEntry(selectedTimeEntry, { description })
      updateState("selectedTimeEntry", null)
      toggleState("rndModal")
      return
    }
    updateRndEntry({ ...rnd_entry, description }, selectedTimeEntry)
    updateState("selectedTimeEntry", null)
    toggleState("rndModal")
  }, [description, rnd_entry, selectedTimeEntry, updateRndEntry, toggleState])

  if (!rndModal ) return null

  return (
    <RenderModal>
      <ModalWrapper
        heading="Research and Development Entry"
        closeModal={() => toggleState("rndModal")}
        submitButtonText="Submit"
        onSend={updateDescription}
      >
        <div className="flex flex-col gap-2">
          <label htmlFor="description" className="text-sm font-semibold">Description</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="border border-gray-300 rounded p-2"
          />
        </div>
        {!isEmpty(rnd_entry?.versions) && (
          <div className='w-full py-4'>
            <h3>Revision History</h3>
            <div className="max-h-50vh overflow-y-scroll">
              {rnd_entry.versions.map((revision, index) => <AttributeRevision key={index} revision={revision} />)}
            </div>
          </div>
        )}
      </ModalWrapper>
    </RenderModal>
  )
}

export default RndModal
